import type { ID } from '@octopus-do/octopus-project-core'
import type React from 'react'

import { DropOpenGraph, Image } from './components'
import css from './styles.module.css'

interface Props {
  image: { id: ID; value: string } | null
  labelClassName: string
  nodeId: ID
  readOnly: boolean
  canEdit: boolean
}

export const OpenGraphImage: React.FC<Props> = ({
  image,
  labelClassName,
  nodeId,
  readOnly,
  canEdit,
}) => (
  <div className={css.open_graph_image}>
    <div className={labelClassName}>Open Graph image</div>

    {!image && (
      <DropOpenGraph
        cnClassName={css.open_graph_image_wrap}
        nodeId={nodeId}
        hasAccess={canEdit}
        readOnly={readOnly}
      />
    )}

    {image && (
      <Image
        image={image}
        nodeId={nodeId}
        hasAccess={canEdit}
        readOnly={readOnly}
      />
    )}
  </div>
)
